import {ISelectOption} from '@features/orders/interfaces';
import {getFilterSuggestions} from '@features/orders/services/getFilterSuggestions';

export function getStatuses(searchText: string = ''): Promise<ISelectOption[]> {
    return getFilterSuggestions('status', searchText);
}